import { Injectable } from '@angular/core';
import { BaseFormService } from '../BaseFormService';
import { Observable } from 'rxjs';
import { UtilityService } from '../utility.service';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class CostAllocationFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(`${environment.apiUrl}project-grant/clients/$$clientId$$/cost-allocation-form`, httpClient, utilityService);
	}
	getForm(clientId: string, id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.getUrl(clientId)}/${id}`).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
	inActiveCustomerFeedbackSurvey(clientId: string, id: any) {
		return this.httpClient.delete(`${this.getUrl(clientId)}/${id}/delete`).pipe();
	}
	checkForDuplicate(
		clientId: string,
		currentFormId: string,
		allocationTypeIds: string[],
		glAccountIds: string[]
	): Observable<any> {
		const requestData = {
			currentFormId,
			allocationTypeIds,
			glAccountIds,
		};
		return this.httpClient.post<any>(`${this.getUrl(clientId)}/check-duplicate`, requestData);
	}
	getPreviousData(
		clientId: string,
		glAccountId: string,
		projectGrantId: string,
		projectGrantTaskId: string,
		fiscalYear: number
	): Observable<any> {
		return this.httpClient
			.get<any>(
				`${this.getUrl(clientId)}/previous-data/${glAccountId}/${projectGrantId}/${projectGrantTaskId}/${fiscalYear}`
			)
			.pipe();
	}
	getPoolYTDActual(clientId: string, glAccountId: string, fiscalYear: number): Observable<number> {
		return this.httpClient.get<number>(`${this.getUrl(clientId)}/pool-ytd-actual/${glAccountId}/${fiscalYear}`);
	}
}
